// Service Management Permissions

export const SERVICES_INDEX = 49;
export const SERVICES_CREATE = 50;
export const SERVICES_UPDATE = 51;
export const SERVICES_DELETE = 52;
export const SERVICES_FINISH_ASSIGN = 54;
export const SERVICES_RESTORE = 1379;
